<template>
  <div>
    <transition name="inbox-wrapper-transition">
      <div v-show="showInbox" class="inbox-wrapper">
        <div class="inbox">
          <div class="close-btn" @click="closeButtonClicked"></div>
          <div v-if="showNavBar" class="inbox-navigation-bar">
            <div class="logo" v-if="!selectedMessage">
              <img v-if="navBarLogo" :src="navBarLogo">
            </div>
            <div class="back-button" v-if="selectedMessage" @click="backToList">{{translations.backToList}}</div>
            <h1 v-if="!selectedMessage" class="title">{{translations.inboxHeader}}</h1>
            <div class="contact-details" :class="{'hidden' : !selectedMessage}">
              {{translations.questionsTop}}
              <br>
              <a :href="mailtoLink" :target="supportLinkOpenInNewTab ? '_blank' : '_self'">{{ supportText }}</a>
            </div>
          </div>
          <div class="no-messages" v-if="!selectedMessage && messages.length == 0 && !isLoading">
            <svg width="63px" height="43px" viewBox="0 0 63 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Mail-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M0,43 L63,43 L63,0 L0,0 L0,43 Z M5.66092007,3.18854454 L57.3390799,3.18854454 L31.499032,26.5529311 L5.66092007,3.18854454 Z M41.7909099,21.4925245 L59.8994653,5.11622355 L59.8994653,37.8678287 L41.7909099,21.4925245 Z M3.09666267,5.11622355 L21.205218,21.4925245 L3.09666267,37.8678287 L3.09666267,5.11622355 Z M39.4425187,23.6135695 L57.3545681,39.8114555 L5.64543192,39.8114555 L23.5536093,23.6135695 L31.499032,30.7970144 L39.4425187,23.6135695 Z" id="Fill-1" fill="#000000"></path>
                <!-- eslint-disable-line -->
              </g>
            </svg>
            <span>{{translations.inboxEmpty}}</span>
          </div>
          <div v-if="isLoading" class="spinner-wrapper">
            <Spinner></Spinner>
          </div>
          <div v-show="!selectedMessage" v-if="messages.length > 0 && !isLoading" class="messages-list-wrapper">
            <ul class="messages-list">
              <Listitem v-for="message in messages" :message="message" :key="message.MessageId" :locale="locale" :class="dynamicCSSClass(message)" @clicked-message="showMessage" @delete-message="deleteMessage"></Listitem>
            </ul>
          </div>
          <Inboxmessage v-if="selectedMessage" :authToken="authToken" :fusionUrl="fusionUrl" :class="dynamicCSSClass(selectedMessage)" :message="selectedMessage" :translations="translations" :contactEmail="contactEmail" :mailtoLink="mailtoLink" :supportText="supportText" @hrefClicked="notificationHrefClicked" :showNavBar="showNavBar" :termsAboveButtons="termsAboveButtons" @messageRead="markAsRead"></Inboxmessage>
        </div>
        <div @click="fogClicked" class="overlay-fog">
        </div>
      </div>
    </transition>
    <div class="small-notifications-wrapper">
      <NotificationSmall v-for="notification in notifications" :key="notification.MessageId" @closeNotification="closeNotification" @readMoreClicked="readMoreClicked" @hrefClicked="notificationHrefClicked" :class="dynamicCSSClass(notification)" :notification="notification" :translations="translations"></NotificationSmall>
    </div>
  </div>
</template>

<script>
import Pusher from 'pusher-js';
import Listitem from './Listitem.vue';
import Inboxmessage from './Inboxmessage.vue';
import Spinner from '../Spinner/Spinner.vue';
import NotificationSmall from './Notificationsmall.vue';

import {
  GetUserNotifications,
  DeleteUserNotification,
  MarkNotificationAsRead,
} from '../../api/inbox';
import { log, logWarn } from '../../utils/log';

export default {
  name: 'Inbox',
  components: {
    Listitem,
    Inboxmessage,
    Spinner,
    NotificationSmall,
  },
  props: {
    authToken: {
      type: String,
    },
    overridePusherAuthToken: {
      type: String,
      default: '',
    },
    fusionUrl: {
      type: String,
    },
    pusherKey: {
      type: String,
    },
    pusherRegion: {
      type: String,
      default: 'eu',
    },
    userId: {
      type: Number,
    },
    brandId: {
      type: [String, Number],
    },
    brandName: {
      type: String,
    },
    showInbox: {
      type: Boolean,
    },
    locale: {
      type: Object,
    },
    translations: {
      type: Object,
    },
    navBarLogo: {
      type: String,
    },
    contactEmail: {
      type: String,
    },
    supportLink: {
      type: String,
      default: '',
    },
    supportLinkText: {
      type: String,
      default: '',
    },
    supportLinkOpenInNewTab: {
      type: Boolean,
      default: false,
    },
    termsAboveButtons: {
      type: Boolean,
    },
    closeModalOnFogClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNavBar: true,
      messages: [],
      notifications: [],
      shoutouts: [],
      unreadNotificationsCount: 0,
      selectedMessage: null,
      isLoading: true,
      pusher: null,
      channelName: '',
      shouldAnimateTransitions: true,
      channel: null,
      initialLoadDone: false,
    };
  },
  mounted() {
    window.addEventListener('send-local-message', (payload) => {
      this.sendLocalNotification(payload.detail);
    });

    this.initInbox();
  },
  methods: {
    dynamicCSSClass(notification) {
      if (!notification) {
        return '';
      }

      if (notification && notification.Data && notification.Data.DynamicCSSClass) {
        return `ft-notification-type-${notification.Event} ft-notification-dynamic-class-${notification.Data.DynamicCSSClass}`;
      }

      return `ft-notification-type-${notification.Event}`;
    },
    initInbox() {
      this.$emit('inboxMounted');
      this.shouldAnimateTransitions = true;
      if (this.authToken && this.authToken !== '') {
        this.setupPusher();
        this.fetchInitial();
        this.updateInboxBadge();
      } else {
        this.isLoading = false;
      }
    },
    resetInbox() {
      this.showNavBar = true;
      this.messages = [];
      this.notifications = [];
      this.unreadNotificationsCount = 0;
      this.selectedMessage = null;
      this.isLoading = true;
      this.pusher = null;
      this.channelName = '';
      this.shouldAnimateTransitions = true;
      this.channel = null;
    },
    unbindPusher() {
      if (this.pusher) {
        this.pusher.disconnect();
        this.pusher.connection.unbind_all();
      }
      if (this.channel) this.channel.unbind_all();
    },
    fetchInitial() {
      GetUserNotifications(this.fusionUrl, this.authToken, false)
        .then((response) => {
          this.isLoading = false;
          if (response.data && response.data.Data) {
            this.messages = response.data.Data.filter(a => a.Event === 'inbox');
            this.unreadNotificationsCount = this.messages.reduce(
              (sum, message) => (message.IsRead == null ? sum : sum + !message.IsRead),
              0,
            );

            this.notifications.push(...response.data.Data.filter(
              a => (a.Event === 'message'
                || (a.Event === 'inbox' && a.DisplayType === 'push'))
                && !a.IsRead,
            ));

            const shoutouts = response.data.Data.filter(
              s => s.Event === 'shoutout' && !s.IsRead && s.MessageId > 0,
            );
            if (shoutouts.length > 0) this.shoutouts.push(...shoutouts);
            this.showAvailableShoutouts();
          } else if (
            response.data
            && response.data.Errors
            && response.data.Errors.length > 0
          ) {
            logWarn('Could not fetch notifications', response.data.Errors);
          } else {
            logWarn('Could not fetch notifications', null);
          }
        })
        .catch((error) => {
          logWarn('Could not fetch notifications', error);
        });
    },
    generateFakeMessageId() {
      const u = new Date() * 1000;
      return u - (u * 2);
    },
    sendLocalNotification(params) {
      const message = params;
      if (!(message.Event === 'message' || message.Event === 'shoutout' || message.Event === 'inbox')) return false;
      message.MessageId = this.generateFakeMessageId();
      message.IsLocalMessage = true;

      if (message.Event === 'inbox' && message.DisplayType !== 'silent') this.notifications.push(message);
      if (message.Event === 'inbox') this.addMessageToInbox(message);
      if (message.Event === 'message') this.notifications.push(message);
      if (message.Event === 'shoutout') this.shoutouts.push(message);
    },
    setupPusher() {
      Pusher.logToConsole = process.env.NODE_ENV !== 'production';
      this.pusher = new Pusher(this.pusherKey, {
        channelAuthorization: {
            endpoint: `${this.fusionUrl}/external/pusher/${this.brandName}?authToken=${this.authToken}`
          },
        cluster: this.pusherRegion,
        encrypted: true,
        enableStats: false,
      });
    },
    notificationHrefClicked(payload) {
      this.$emit('toggleInbox');
      if (payload.data.Event === 'inbox') {
        window.location = payload.href;
        return;
      }

      const finallyCallback = () => {
        const notificationIndex = this.notifications.findIndex(
          notification => notification.MessageId === payload.data.MessageId,
        );

        if (notificationIndex > -1) {
          this.notifications.splice(notificationIndex, 1);
        }
        setTimeout(() => {
          window.location = payload.href;
        }, 500);
      }

      // Doing like this instead of .finally because of polyfill issues
      this.markAsRead(payload.data).then(finallyCallback).catch(finallyCallback);
    },
    closeNotification(message) {
      const notificationIndex = this.notifications.findIndex(
        notification => notification.MessageId === message.MessageId,
      );

      if (notificationIndex > -1) {
        this.notifications.splice(notificationIndex, 1);
      }

      if (!message.IsLocalMessage) this.markAsRead(message);
      if (message.Event === 'inbox' && !message.IsRead) {
        this.decrementUnreadNotificationsCount();
        message.IsRead = true;
      }
    },
    addMessageToInbox(message) {
      if (message && message.Event === 'inbox') {
        this.incrementUnreadNotificationsCount();
        this.messages.unshift(message);
      }
    },
    showAvailableShoutouts() {
      if (this.shoutouts.length === 0 || this.selectedMessage !== null || this.showInbox) return;
      this.openSpecificMessage(this.shoutouts[0], false);
    },
    onInbox(data) {
      if (!data || !data.MessageId) return;
      this.addMessageToInbox(data);
      this.notifications.push(data);
    },
    onMessage(data) {
      if (!data || !data.MessageId) return;
      this.notifications.push(data);
    },
    onShoutout(data) {
      if (!data || !data.MessageId) return;
      this.shoutouts.push(data);
      this.showAvailableShoutouts();
    },
    onConnected(data) {
      log('Connected to ws channel:', this.channelName);
    },
    onDisconnected(data) {
      logWarn('Disconnected from ws channel:', this.channelName);
    },
    onSubscription(data) {
      log(data, this.channelName);
    },
    onSubscriptionSuccess(data) {
      log('Successfully subscribed to ws channel:', this.channelName);
    },
    backToList() {
      this.selectedMessage = null;
    },
    closeButtonClicked() {
      this.$emit('toggleInbox');

      if (this.selectedMessage && this.selectedMessage.Event === 'shoutout') {
        this.markAsRead(this.selectedMessage);

        const shoutoutIndex = this.shoutouts.findIndex(
          shoutout => shoutout.MessageId === this.selectedMessage.MessageId,
        );

        if (shoutoutIndex > -1) {
          this.shoutouts.splice(shoutoutIndex, 1);
        }
      }

      setTimeout(() => {
        this.selectedMessage = null;
        this.showNavBar = true;
      }, 500);

      setTimeout(() => {
        this.showAvailableShoutouts();
      }, 1000);
    },
    readMoreClicked(message) {
      this.openSpecificMessage(message, true);
      this.closeNotification(message);
    },
    openSpecificMessage(message, showNavBar) {
      this.shouldAnimateTransitions = false;
      this.selectedMessage = message;
      this.$emit('toggleInbox');
      this.showNavBar = showNavBar;
    },
    deleteMessage(messageId) {
      const ok = confirm(this.translations.deleteMessagePrompt); // eslint-disable-line
      if (ok) {
        DeleteUserNotification(this.fusionUrl, this.authToken, messageId)
          .then((response) => {
            if (!response.data.Success) {
              if (response.data.Errors && response.data.Errors.length > 0) {
                logWarn('Could not delete notification.', response.data.Errors);
              }
              return;
            }

            this.messages.forEach((message, index) => {
              if (message.MessageId === messageId) {
                this.messages.splice(index, 1);
                if (!message.IsRead) {
                  this.closeNotification(message);
                }
              }
            });
          })
          .catch((error) => {
            logWarn('Could not delete notification.', error);
          });
      }
    },
    showMessage(messageId) {
      const m = this.messages.find(
        obj => obj.MessageId === messageId,
      );

      this.closeNotification(m);
      m.IsRead = true;
      this.selectedMessage = m;
    },
    markAsRead(message) {
      return new Promise((resolve, reject) => {
        if (!message || !message.MessageId || message.IsRead) return resolve();

        MarkNotificationAsRead(this.fusionUrl, this.authToken, message.MessageId)
          .then((response) => {
            if (!response.data || !response.data.Success) {
              if (response.data && response.data.Errors && response.data.Errors.length > 0) {
                logWarn('Could not mark notification as read', response.data.Errors);
                return reject();
              }
              logWarn('Could not mark notification as read', null);
              return reject();
            }
            return resolve();
          })
          .catch((error) => {
            logWarn('Could not mark notification as read', error);
            return reject();
          });
      });
    },
    updateInboxBadge() {
      this.$emit('unreadBadgeChanged', this.unreadNotificationsCount);
    },
    incrementUnreadNotificationsCount() {
      this.unreadNotificationsCount = this.unreadNotificationsCount + 1;
    },
    decrementUnreadNotificationsCount() {
      this.unreadNotificationsCount = this.unreadNotificationsCount - 1;
      if (this.unreadNotificationsCount < 0) this.unreadNotificationsCount = 0;
    },
    fogClicked(e) {
      if (e.target.classList.contains('overlay-fog') && this.closeModalOnFogClick) {
        this.closeButtonClicked();
      }
    },
  },
  watch: {
    authToken() {
      if (this.initialLoadDone) return;

      if (this.authToken !== '' && this.authToken !== null) {
        this.unbindPusher();
        this.initInbox();
        this.initialLoadDone = true;
      } else {
        this.unbindPusher();
        this.resetInbox();
      }
    },
    unreadNotificationsCount() {
      // eslint-disable-line
      this.updateInboxBadge();
    },
    pusher() {
      if (this.pusher) {
        this.channelName = `private-prisma-${this.brandId}-${this.userId}`; /* eslint-disable-line */
        this.pusher.connection.bind('connected', data => this.onConnected(data));
        this.pusher.connection.bind('disconnected', data => this.onDisconnected(data));
        this.channel = this.pusher.subscribe(this.channelName);
        this.channel.bind('pusher:subscription_error', data => this.onSubscription(data));
        this.channel.bind('message', data => this.onMessage(data));
        this.channel.bind('shoutout', data => this.onShoutout(data));
        this.channel.bind('inbox', data => this.onInbox(data));
        this.channel.bind('pusher:subscription_succeeded', data => this.onSubscriptionSuccess(data));
      }
    },
  },
  computed: {
    mailtoLink() {
      return this.supportLink === '' ? `mailto:${this.contactEmail}` : this.supportLink;
    },
    supportText() {
      return this.supportLink === '' ? this.contactEmail : this.supportLinkText;
    },
  },
};
</script>

<style lang="less">
@import (css) url("https://fonts.googleapis.com/css?family=Lato:400,700,900");

@maxWidth: 600px;
@navBarHeight: 55px;
@borderRadius: 6px;

#fasttrack-crm {
  z-index: 999999; /* Trying to override all chat buttons and similiar */

  .cta-button {
    cursor: pointer;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 700;
    background-color: #0e9543;
    color: white;
    border-radius: 4px;
    box-shadow: -2px -2px 0px inset rgba(0, 0, 0, 0.3);
    display: inline-block;
    padding: 15px 15px;
    margin-bottom: 10px;
    text-decoration: none;
    outline: none;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-font-smoothing: antialiased;

    &.secondary {
      color: #000;
      background-color: #f6cd34;
    }

    &:hover {
      &:before {
        background-color: rgba(0, 0, 0, 0.15);
      }
    }

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-radius: 4px;
      transition: all 0.2s linear;
    }
  }

  .overlay-fog {
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  .hidden {
    opacity: 0;
  }

  .inbox-wrapper {
    font-family: "Lato", sans-serif;
    background-color: rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999999; /* Trying to override all chat buttons and similiar */
    min-width: 100vw;
    min-height: 85vh;

    * {
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
    }
  }

  .inbox-wrapper-transition-enter-active,
  .inbox-wrapper-transition-leave-active {
    transition: opacity 0.2s;
  }
  .inbox-wrapper-transition-enter,
  .inbox-wrapper-transition-leave-to {
    opacity: 0;
  }

  .inbox {
    width: 95%;
    max-width: @maxWidth;
    min-height: 200px;
    max-height: 96%;
    background-color: white;
    border-radius: @borderRadius;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
    z-index: 5000;
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    margin-top: 10px;

    @media all and (max-width: 768px) {
      height: 100vh;
      margin-bottom: 0px;
    }
  }

  .inbox-navigation-bar {
    height: @navBarHeight;
    min-height: @navBarHeight;
    padding: 10px 30px 10px 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: @borderRadius @borderRadius 0px 0px;
    box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
    z-index: 1;

    .logo {
      width: 100px;
      height: 100%;
      display: flex;
      align-items: center;

      img {
        max-height: 100%;
        height: auto;
        max-width: 100%;
        width: auto;
        display: inline-block;
      }
    }

    h1.title {
      font-family: "Lato", sans-serif;
      padding: 0;
      font-size: 18px;
      font-weight: 900;
      color: #333;
    }

    .contact-details {
      font-size: 8px;
      line-height: 1;
      color: #000;
      text-align: right;
      width: 100px;

      a {
        text-decoration: none;
        color: inherit;
      }
    }
  }

  .spinner-wrapper {
    width: 100%;
    height: 100%;
    max-height: ~"calc(100% - @{navBarHeight})";
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .no-messages {
    height: 100%;
    max-height: ~"calc(100% - @{navBarHeight})";

    fill: rgba(0, 0, 0, 0.3);

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 70px;
    margin-bottom: 70px;

    span {
      font-size: 20px;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.3);
      max-width: 200px;
      text-align: center;
    }

    svg {
      width: 75px;
      height: auto;
      margin-bottom: 20px;

      fill: inherit;
      g {
        fill: inherit;
        path {
          fill: inherit;
        }
      }
    }
  }

  .close-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -7px;
    margin-top: -7px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    transition: all 0.1s ease-in-out;
    z-index: 500;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 9px;
      left: 15px;
      width: 2px;
      height: 15px;
      border-radius: 2px;
      background-color: #333;
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }

    &:hover {
      transform: scale(1.1);
    }
  }

  .back-button {
    cursor: pointer;
    border-radius: 2px;
    height: 24px;
    padding: 0px 10px;
    position: relative;
    padding-left: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 1;
    font-weight: 900;
    color: #000;

    &:before,
    &:after {
      content: "";
      position: absolute;
      background-color: #000;
      left: 8px;
      top: 50%;
      margin-top: -6px;
      width: 2px;
      height: 7px;
      border-radius: 1px;
      -webkit-transform: rotate(30deg);
      transform: rotate(30deg);
    }

    &:after {
      margin-top: -1px;
      -webkit-transform: rotate(-30deg);
      transform: rotate(-30deg);
    }
  }

  .messages-list-wrapper {
    width: 100%;
    height: 100%;
    min-height: 60vh;
    overflow: hidden;
    border-radius: 0px 0px @borderRadius @borderRadius;
    max-height: ~"calc(100% - @{navBarHeight})";
    position: relative;
  }

  .messages-list {
    position: absolute;
    top: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: @maxWidth;
    height: 100%;
    list-style-type: none;
    overflow-y: scroll;
    display: block;
  }

  .message {
    cursor: pointer;
    position: relative;
    padding: 10px 20px 10px 30px;
    height: 100px;
    box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;

    &:nth-child(odd) {
      background-color: rgba(0, 0, 0, 0.01);
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .unread-badge {
    position: absolute;
    top: 35px;
    left: 10px;
    background-color: #5480ef;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }

  h4.title {
    font-family: "Lato", sans-serif;
    margin: 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  p.text {
    font-family: "Lato", sans-serif;
    margin: 0;
    padding: 0;
    padding-top: 3px;
    padding-right: 20px;
    display: block;
    display: -webkit-box;
    max-width: ~"calc(@{maxWidth} - 50px)";
    min-height: 15px;
    max-height: 30px;
    font-size: 12px;
    line-height: 1.2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333;
    text-align: left;
  }

  p.date {
    font-family: "Lato", sans-serif;
    padding: 0;
    margin: 0;
    margin-top: 3px;
    color: #545454;
    font-size: 8px;
    text-align: left;
  }

  .delete-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    fill: rgba(0, 0, 0, 0.1);
    width: 40px;
    height: 40px;

    &:hover {
      fill: rgba(0, 0, 0, 0.4);
    }

    svg {
      margin: 10px;
      width: 20px;
      height: 20px;

      fill: inherit;
      g {
        fill: inherit;
        path {
          fill: inherit;
        }
      }
    }
  }

  .small-notifications-wrapper {
    box-sizing: border-box;
    position: fixed;
    right: 0;
    padding: 10px 15px 0px 15px;
    top: 15px;
    width: 100%;
    max-width: 450px;
    overflow: hidden;
    display: flex;
    flex-direction: column-reverse;
    z-index: 999;
    text-align: left;

    @media all and (max-width: 768px) {
      max-width: none;
    }
  }
}
</style>
